import { ref, onMounted, onBeforeUnmount } from 'vue'

export const useTableLayout = () => {
  const tableHeight = ref(0)

  // thead height from CSS (.ant-table-thead > tr > th { height: 46px })
  const THEAD_HEIGHT = 46

  const calculateTableHeight = () => {
    const revenueHeaderEl = document.querySelector('.revenue-header')
    const revenueHeaderHeight = revenueHeaderEl ? revenueHeaderEl.clientHeight : 0
    document.documentElement.style.setProperty('--revenue-header-height', `${revenueHeaderHeight}px`)
    const tableContainerEl = document.querySelector('.settlement-table .table-container')
    if (!tableContainerEl) return
    tableHeight.value = tableContainerEl.clientHeight - THEAD_HEIGHT
  }

  onMounted(() => {
    calculateTableHeight()
    window.addEventListener('resize', calculateTableHeight)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', calculateTableHeight)
  })

  return { tableHeight }
}
